"use client";

import { createContext, useContext } from "react";

import type { PublicIdHrefResolver } from "./public-id-links";

/**
 * Ambient id → href resolver for markdown surfaces.
 *
 * Context and hook live here, apart from the provider component in
 * `public-id-link-provider.tsx`: a module that exports both a component and a
 * non-component breaks Fast Refresh for everything importing it.
 */
export const PublicIdLinkContext = createContext<PublicIdHrefResolver | null>(null);

/** The ambient resolver, or `null` outside a `PublicIdLinkProvider`. */
export function usePublicIdHrefResolver(): PublicIdHrefResolver | null {
  return useContext(PublicIdLinkContext);
}
